var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-resolver',[_c('incident-view-client',{attrs:{"slot":"clientView"},slot:"clientView"}),_c('incident-view-hospital',{attrs:{"slot":"hospitalView"},slot:"hospitalView"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }